import { t } from 'i18next';
import * as React from 'react';
import { IOWidget, mk_widget } from 'widgets-for-react';
import { createButtonData } from '../../../utils';
import { CMSState } from '../../cms/blocks/types.gen';
import { PublicSiteState } from '../../public_site.main.mod';
import { HeaderBlock } from '../blocks/custom_blocks/widgets/headerBlock.mod';

export const notfound_page: IOWidget<PublicSiteState, never> = (public_state:PublicSiteState) => mk_widget({
  run: o => (

    <div className="error-wrapper">
      {HeaderBlock({
        blockName: 'vidda/header',
        title: t('404.title'),
        intro: t('404.description'),
        primary_button: createButtonData('404.homepage','404.link'),
        header_type: 'error'
      }, { style: {} })({} as CMSState<{}, {}, never>)(public_state).run(_ => {})}
    </div>

  )
})
